export enum MessageValue {
    PropertyName = "PropertyName",
    MaxLength = "MaxLength",
    TotalLength = "TotalLength",
}
